import CartIcon from '../../../styles/staticAssets/images/Bucket-Cart.svg';
import Account from '../../../styles/staticAssets/images/Icon_Account.svg';

const HEADER_DATA = {
  contentData: {
    headerContent: {
      kfcLogo: {
        src: '',
        alt: '',
      },
      navLeft: [
        {
          name: 'Menu',
          linkTo: '',
          imageUrl: '',
        },
        {
          name: 'Deals',
          linkTo: '',
          imageUrl: '',
        },
        {
          name: 'Catering',
          linkTo: '',
          imageUrl: '',
        },
      ],
      navRight: [
        {
          name: '',
          linkTo: '',
          url: '',
          type: 'Language Selector',
          options: ['Eng', 'Fr', 'De'],
        },
        {
          name: 'Sign In',
          linkTo: '',
          url: Account,
        },
        {
          name: '',
          linkTo: '',
          url: CartIcon,
        },
      ],
      navMobileMenu: {
        threeLineIcon: {
          src: '',
          alt: '',
        },
        letsGetCookingText: {
          name: 'letsgetcook',
        },
      },
    },
  },
};

export default HEADER_DATA;
